/*
  This is the exception wrapper for steps
 */

import React from 'react'
import {  useSelector } from "react-redux";

import AttributeStep from './steps/AttributeStep';
import OptionalAttributeStep from "./steps/OptionalAttributeStep";
import PatternStepByStep from "./PatternStepByStep";

import RowConfigStep from "./steps/RowConfigStep";

const StepByStep = (props) => {
    const product = useSelector(state => state.productDataReducer)

    const optionalAttributes = useSelector(state => state.productSelectionsReducer.optionalAttributes)
    const requiredSelections = useSelector(state => state.productSelectionsReducer.requiredSelections)
    const optionalSelections = useSelector(state => state.productSelectionsReducer.optionalSelections)
    const isPattern = useSelector(state => state.configuratorStateReducer.isPattern)
    const showOptions = useSelector(state => state.configuratorStateReducer.displayOptionalAndSummary)

    const perModuleAttributes = useSelector(state => state.productSelectionsReducer.perModuleAttributes);
    const perModuleSelections = useSelector(state => state.productSelectionsReducer.perModuleSelections);

    const displaySteps = () => {
        const steps = [];
        // product selector sets the first attirubte selection, it copies attribute from
        // returned attribute options, and sets value to nil.
        if(requiredSelections != null) {

            // every
            requiredSelections.forEach(function (el, index) {
                steps.push(<AttributeStep key={el.id} attributes={el} currentValue={el.selection} index={index}></AttributeStep>)
            });
        }
        return (
            steps
        )
    }

    const displayOptions = () => {
        if(showOptions) {
            return (
                <div>
                    <OptionalAttributeStep options={optionalAttributes} currentValues={optionalSelections} />
                    <RowConfigStep selections={perModuleSelections} attributes={perModuleAttributes}/>
                </div>
            )
        }
    }

    const displayPatternSteps = () => {
        if(isPattern){
            // since pattern sides appear after options, display pattern options when options are displayed
            if(showOptions) {
                return <PatternStepByStep product={product}
                                          currentValues={props.product.quote_item_selections}/>
            }
        }
    }
    
    return (
        <div className="panel">
            { displaySteps() }
            { displayOptions() }
            { displayPatternSteps() }
        </div>
    )
    
}

export default StepByStep;
